import axios from 'axios';
import Api from "./Api";

class BasicInfoAPI extends Api{


    getProcessingGroups(){
        let path = "/processing_group";
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._get(endpoint).then(response =>  response)
    }


    getMaterials(){
        let path = "/material";
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._get(endpoint).then(response =>  response)
    }

    getMaterialFaces(){
        let path = "/material_face";
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._get(endpoint).then(response =>  response)
    }

    getEquipments(){
        let path = "/equipment";
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._get(endpoint).then(response =>  response)
    }

    getItemGroups(){
        let path = "/item_group";
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._get(endpoint).then(response =>  response)
    }

    getSizeItems(){
        let path = "/size_item";
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._get(endpoint).then(response =>  response)
    }

    getStaffs(){
        let path = "/user";
        let endpoint =  this.combineUrl(this.apiHost,path);
        return this._get(endpoint).then(response =>  response)
    }

}

let _api = new BasicInfoAPI();

export default _api;